import React, { useState } from 'react';
import { Brain, Zap, Sparkles, MessageSquare, Eye, BarChart3, Cpu, ArrowRight, CheckCircle } from 'lucide-react';

const MobileAISection: React.FC = () => {
  const [showComingSoon, setShowComingSoon] = useState(false);

  const handleComingSoon = () => {
    setShowComingSoon(true);
    window.setTimeout(() => setShowComingSoon(false), 3000);
  };

  const aiServices = [
    {
      icon: MessageSquare,
      title: 'Chatbots Intelligents',
      description: 'Assistants virtuels 24/7 qui comprennent vos clients',
      color: 'from-amber-500 to-amber-600'
    },
    {
      icon: Eye,
      title: 'Vision par Ordinateur',
      description: 'Analyse et reconnaissance d\'images automatique',
      color: 'from-amber-400 to-amber-500'
    },
    {
      icon: BarChart3,
      title: 'Analyse Prédictive',
      description: 'Anticipez les tendances et optimisez vos décisions',
      color: 'from-amber-500 to-orange-500'
    },
    {
      icon: Cpu,
      title: 'Automatisation Intelligente',
      description: 'Robots logiciels qui automatisent vos tâches',
      color: 'from-amber-600 to-orange-600'
    }
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-blue-950 via-blue-900 to-slate-900 text-white">
      {/* Effets de fond */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-5 w-40 h-40 bg-amber-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-5 w-48 h-48 bg-orange-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 px-4 py-12">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Brain className="w-10 h-10 text-amber-400" />
            <Sparkles className="w-6 h-6 text-amber-500 animate-pulse" />
            <Zap className="w-8 h-8 text-amber-400" />
          </div>
          
          <h2 className="text-3xl font-bold mb-3">
            <span className="bg-gradient-to-r from-amber-300 via-amber-400 to-amber-500 bg-clip-text text-transparent">
              Intelligence Artificielle
            </span>
          </h2>
          
          <p className="text-sm text-gray-300 leading-relaxed max-w-md mx-auto">
            L'IA transforme radicalement votre façon de travailler et d'interagir avec vos clients
          </p>
        </div>

        {/* Services IA Grid */}
        <div className="grid grid-cols-1 gap-4 mb-8">
          {aiServices.map((service, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-5 active:scale-95 transition-all duration-200"
              onClick={handleComingSoon}
            >
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 w-12 h-12 bg-gradient-to-r ${service.color} rounded-xl flex items-center justify-center`}>
                  <service.icon className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-bold text-white mb-1">
                    {service.title}
                  </h3>
                  <p className="text-xs text-gray-400 leading-relaxed">
                    {service.description}
                  </p>
                </div>
                <ArrowRight className="w-5 h-5 text-gray-400 flex-shrink-0 mt-1" />
              </div>
            </div>
          ))}
        </div>

        {/* CTA Principal */}
        <div className="bg-gradient-to-r from-blue-900/30 to-blue-800/20 backdrop-blur-sm border border-amber-400/20 rounded-2xl p-6 text-center">
          <h3 className="text-xl font-bold text-white mb-3">
            L'IA : Le Moteur de l'Innovation
          </h3>
          
          <p className="text-sm text-gray-300 leading-relaxed mb-6">
            Ne restez pas spectateur de cette révolution, <strong className="text-white">devenez-en l'acteur principal.</strong>
          </p>

          <div className="grid grid-cols-3 gap-3 mb-6">
            <div className="bg-white/5 rounded-xl p-3">
              <Brain className="w-8 h-8 text-amber-400 mx-auto mb-2" />
              <p className="text-xs font-semibold text-white">Intelligence Augmentée</p>
            </div>
            
            <div className="bg-white/5 rounded-xl p-3">
              <Zap className="w-8 h-8 text-amber-400 mx-auto mb-2" />
              <p className="text-xs font-semibold text-white">Automatisation Totale</p>
            </div>
            
            <div className="bg-white/5 rounded-xl p-3">
              <CheckCircle className="w-8 h-8 text-amber-400 mx-auto mb-2" />
              <p className="text-xs font-semibold text-white">Croissance Exponentielle</p>
            </div>
          </div>

          <button 
            onClick={handleComingSoon}
            className="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white py-3.5 rounded-xl font-bold shadow-lg hover:shadow-xl hover:shadow-amber-500/30 transition-all flex items-center justify-center gap-2"
          >
            <Brain className="w-5 h-5" />
            <span>Découvrir nos solutions IA</span>
          </button>

          {showComingSoon && (
            <p className="mt-4 text-amber-300 font-semibold animate-pulse">
              Bientôt disponible
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default MobileAISection;
